const currentOrigin = window.location.origin;

function normalizeUrl(value: string | undefined, fallback: string): string {
  const trimmed = value?.trim();
  return trimmed && trimmed.length > 0 ? trimmed.replace(/\/+$/, "") : fallback;
}

const deploymentMode = import.meta.env.VITE_DEPLOYMENT_MODE?.trim() || "protected-preview";
const useSameOriginProxy = deploymentMode === "protected-preview";

export const frontendEnv = {
  deploymentMode,
  defaultLanguage: import.meta.env.VITE_DEFAULT_LANGUAGE?.trim() || "ro",
  publicApiBaseUrl: useSameOriginProxy ? currentOrigin : normalizeUrl(import.meta.env.VITE_PUBLIC_API_BASE_URL, currentOrigin),
  publicMediaBaseUrl: useSameOriginProxy ? currentOrigin : normalizeUrl(import.meta.env.VITE_PUBLIC_MEDIA_BASE_URL, currentOrigin),
  referenceJsonPath: `${currentOrigin}/data/village-reference.json`,
};